import { render, staticRenderFns } from "./AddAdmin.vue?vue&type=template&id=3c2ba68a&scoped=true&"
import script from "./AddAdmin.vue?vue&type=script&lang=js&"
export * from "./AddAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AddAdmin.vue?vue&type=style&index=0&id=3c2ba68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2ba68a",
  null
  
)

export default component.exports